/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AxiosError, AxiosInstance } from 'axios';
import { createApiErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createApiErrorHandler';
import { createAzureXmlErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createAzureXmlErrorHandler';
import { createEndpointErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createEndpointErrorHandler';
import { createGenericErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createGenericErrorHandler';
import { createHandlersManager } from 'src/core/utils/interceptors/errorHandlers/createHandlersManager';
import { createUnwrapBlobErrorHandler } from 'src/core/utils/interceptors/errorHandlers/createUnwrapBlobErrorHandler';

const handlersManager = createHandlersManager();

handlersManager.add(createUnwrapBlobErrorHandler());
handlersManager.add(createApiErrorHandler());
handlersManager.add(createAzureXmlErrorHandler());
handlersManager.add(createEndpointErrorHandler());
handlersManager.add(createGenericErrorHandler());

/**
 * Tries handling the error received by one of the handlers in the chain.
 */
export const createErrorInterceptor = (client: AxiosInstance) => {
    client.interceptors.response.use(
        null,
        async (error: AxiosError): Promise<Error> =>
            handlersManager.handle(error).then(e => {
                throw { ...e, response: error.response };
            })
    );
};
